import { DatePipe } from "@angular/common";
import {
        Component,
        EventEmitter,
        Input,
        OnInit,
        Output,
        ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { agentOutwardService } from "../../../services/index";

@Component({
  selector: "outward-print",
  templateUrl: "./outwardPrint.html",
})
export class outwardPrint implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  @Input() partydata: any = [];
  partyList: any = [];
  list: any = [];
  agentList: any = [];
  designList: any = [];
  
  printdata: any = {};
  data: any = {};
  dataList: any = [];
  woDetails: any;
  alphabet: string[];
  predefCol: number;
  userDefCol: number;
  dcList : any = [];
  @Input() set printdet(val: any[]) {
    this.printdata = val;
   
    this.getDesignList(this.printdata.aoid);
  }

  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;
  orderfromdtControl: FormControl = new FormControl();
  ordertodtControl: FormControl = new FormControl();
  salesfromdtControl: FormControl = new FormControl();
  salestodtControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    private agentowservice: agentOutwardService,
    public datePipe: DatePipe
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }

  getDesignList(id) {
    const params = {
      aoid: id,
    };
  
    this.agentowservice.PrintagentData(params).then((res: any) => {
      this.dcList = res.data;
      this.data.ref_no = res.data[0].ref_no;
      this.data.type = res.data[0].type;
      this.data.aodt = res.data[0].aodt;
      this.data.total = res.data[0].invpcs;
      this.data.remarks = res.data[0].remarks;

      


      this.dcList.forEach((el) => {
        el.tot = 1;
        
      });
console.log(this.dcList)
  });
}
 
  print(div) {
    var content = document.getElementById(div).innerHTML;

    var mywindow = window.open("", "Print", "height=850,width=1000");

    /*mywindow.document.write('<html><head><title>Print</title>');
    mywindow.document.write('</head><body >');*/
    mywindow.document.write(content);
    //   mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/agentOutward/outwardPrint.ts